import { render, staticRenderFns } from "./CBodyVirtual.vue?vue&type=template&id=ace6a988&"
import script from "./CBodyVirtual.vue?vue&type=script&lang=ts&"
export * from "./CBodyVirtual.vue?vue&type=script&lang=ts&"
import style0 from "./CBodyVirtual.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports